export const interFont = {
  cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap',
}

export const pinStyle = {
  base: {
    fontFamily: 'Inter',
    fontSize: '18px',
  },
}
